import axios from 'axios';

export default {
  methods: {
    renderJiraList(jiraProjects) {
      return `project%20in%20("${jiraProjects.join('", "')}")`;
    },

    scrollTop() {
      const anchor = this.$parent.$el.querySelector('.sd-anchor-top');

      anchor && anchor.scrollIntoView();
      window.scrollBy(0, -160);
    },

    queryAnnouncement(routeKey) {
      const confluenceKey = this.$config[routeKey].announcementConfKey;
      const portal = `portal=%22${this.routeKey}%22`;
      const announcementQuery =
        `/app/${routeKey}/confluence/rest/api/content/search?cql=id=%22` +
        `${confluenceKey}%22%20AND%20${portal}` +
        '&limit=1&expand=space,body.view';
      axios.get(announcementQuery, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        this.announcement = response.data.results[0].body.view.value;
      });
    },

    showAnnouncementSetter(value) {
      this.$store.commit('SET_SHOW_ANNOUNCEMENT', value);
    },

    logError(error) {
      // https://github.com/axios/axios#handling-errors
      /* eslint-disable no-console */
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser
        // and an instance of http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
      /* eslint-enable no-console */
    },

    cqlQueryGenerator(searchValue, portal, start) {
      const search = searchValue ? `text~%22${searchValue}%22%20AND%20` : '';
      return `/app/${this.routeKey}/confluence/rest/api/content/` +
        `search?cql=${search}${portal}%20AND%20type` +
        '!=attachment%20order%20by%20lastModified%20desc&limit=5' +
        `&start=${start}&expand=space,body.view,renderedFields`;
    },

    createParam(param, val) {
      return val ? `%20AND%20${param}=%22${val}%22` : '';
    },

    jqlQueryGenerator(
      searchValue, portal, start, maxResults, searchPersonal, searchJira,
      searchStatus, searchOpened, searchClosed, sortKey, sortOrder,
    ) {
      let generatedQuery = null;
      let jiraParams;
      let resolutionParam;

      const search = searchValue ?
        `text%20~%20%22${searchValue}%22%20AND%20` : '';

      const jiraParam = searchJira ? 'searchJira=%22true%22' : false;
      const personalParam = searchPersonal ? 'searchPerso=%22true%22' : false;

      if (jiraParam && personalParam) {
        jiraParams = `(${jiraParam}%20OR%20${personalParam})`;
      } else {
        jiraParams = !jiraParam ? `(${personalParam})` : `(${jiraParam})`;
      }

      // Handle resolution parameter
      const openedParam = this.createParam('searchOpened', searchOpened);
      const closedParam = this.createParam('searchClosed', searchClosed);
      if (openedParam && closedParam) {
        resolutionParam = '%20AND%20searchResolution=%22all%22';
      } else if (!openedParam && !closedParam) {
        resolutionParam = '';
      } else {
        resolutionParam = openedParam
          ? '%20AND%20searchResolution=%22unresolved%22'
          : '%20AND%20searchResolution=%22done%22';
      }

      const statusParam = openedParam
        ? (
          this.createParam('searchStatus', searchStatus)
            + (
              (searchStatus !== false && searchClosed)
                ? this.createParam('searchStatus', '10001')
                : ''
            )
        )
        : '';

      // Handle sort parameter
      const sortParam = sortKey
        ? `%20AND%20sortOrder=%22${sortOrder}%22%20AND%20sortKey=%22${sortKey}%22`
        : '';

      generatedQuery = `/app/${this.routeKey}/jira/rest/api/2/search?` +
        `jql=${search}${jiraParams}%20AND%20${portal}` +
        `${statusParam}${resolutionParam}${sortParam}` +
        `&maxResults=${maxResults}&expand=renderedFields&startAt=${start}`;

      return generatedQuery;
    },

    renderDate(initialDate) {
      // Render readable Jira & Conf date returned
      const split = initialDate.split('T');
      const date = split[0].split('-');
      return `${date[2]}.${date[1]}.${date[0]}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/Mixins.js